/** Submit and time adjustment handlers for the task form. */
import { useCallback } from 'react';
import {
  MINUTES_IN_DAY,
  formatTime,
} from '@/features/tasks/utils/ui/taskFormUtils';

export const useTaskFormSubmitHandlers = ({
  task,
  setTask,
  validate,
  onSave,
  setIsSubmitting,
}) => {
  const handleTimeChange = useCallback(
    (inc) => {
      const [h, m] = (task.time || '00:00').split(':').map(Number);
      setTask((p) => ({
        ...p,
        time: formatTime(h * 60 + m + inc + MINUTES_IN_DAY),
      }));
    },
    [task.time, setTask],
  );

  const onFormSubmit = useCallback(
    async (e) => {
      if (e) e.preventDefault();
      if (validate() && onSave) {
        setIsSubmitting(true);
        try {
          await onSave(task);
        } finally {
          setIsSubmitting(false);
        }
      }
    },
    [task, onSave, validate, setIsSubmitting],
  );

  return { handleTimeChange, onFormSubmit };
};
